import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import AppLoading from "components/common/AppLoading";
import Page from "components/common/Page";
import Map from "./Map";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles({
  table: {
    width: "100%",
    overflowX: "auto"
  },
  header: {
    display: "flex",
    alignItems: "center"
  },
  mapContainer: {
    marginBottom: 20,
    height: 500,
    width: "100%"
  }
});

export default function POIs({
  loading,
  pois,
  path,
  pathId,
  deletePOI,
  city,
  pathPoints
}) {
  const classes = useStyles();

  if (loading) return <AppLoading />;

  return (
    <Page
      path={path}
      title="Points of Interest"
      crumbs={[
        {
          name: "Cities and Towns",
          href: "/cities"
        },
        {
          name: city.name,
          href: `/cities/${city.id}`
        },
        {
          name: "Points of Interest",
          href: `/cities/${city.id}/pois`
        }
      ]}
    >
      <Button
        color="primary"
        variant="contained"
        href={`/paths/${pathId}/cities/${city.id}/pois/create`}
        style={{ marginBottom: 20 }}
      >
        New Point of Interest
      </Button>

      <div className={classes.mapContainer}>
        <Map center={city.location} pois={pois} pathPoints={pathPoints} />
      </div>

      <Paper className={classes.table}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pois.map(poi => (
              <TableRow key={poi.id}>
                <TableCell component="th" scope="row">
                  {poi.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {poi.draft ? (
                    <Chip label="draft" color="secondary" />
                  ) : (
                    <Chip label="active" color="primary" />
                  )}
                </TableCell>
                <TableCell component="th" scope="row">
                  <Link
                    href={`/paths/${pathId}/cities/${city.id}/pois/edit/${poi.id}`}
                  >
                    Edit
                  </Link>
                  &nbsp;
                  <Link href="#" onClick={() => deletePOI(poi.id)}>
                    Delete
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Page>
  );
}
